import * as _ from "lodash";
import {
    getOfflineSupportRequest,
    getOfflineSupportRequests,
    sendResponse,
    deleteOfflineSupportRequest,
    getWaitingOfflineSupportRequests,
} from "../../api/offlineSupportRequest";
import { maybeCustomer } from "../../utils/request";
import createLogger from "../../utils/log2";

const log = createLogger("offlineSupportRequest");

const offlineSupportRequest = {
    namespaced: true,
    state: {
        offlineSupportRequests: {
            count: 0,
            data: [],
            total: 0,
        },
        waitings: {
            count: 0,
            data: [],
            total: 0,
        },
    },
    getters: {
        waitingOfflineSupportRequestCount(state) {
            log.debug(
                "waitingOfflineSupportRequestCount",
                state.offlineSupportRequests.data.filter((q) => q.status === "new").length,
                state.offlineSupportRequests.data
            );
            return state.offlineSupportRequests.data.filter((q) => q.status === "new").length;
        },
        getWaitingOfflineSupportRequests(state) {
            return state.waitings.data;
        },
    },
    mutations: {
        SET_OFFLINE_SUPPORT_REQUEST: (state, payload) => {
            log.debug("OSR SET_OFFLINE_SUPPORT_REQUEST", payload);
            state.offlineSupportRequests = payload;
        },
        SET_WAITING_OFFLINE_SUPPORT_REQUESTS: (state, payload) => {
            log.debug("SET_WAITING_OFFLINE_SUPPORT_REQUESTS", payload);
            state.waitings = payload;
        },
        ADD_OFFLINE_SUPPORT_REQUESTS: (state, data) => {
            log.debug("OSR ADD_OFFLINE_SUPPORT_REQUEST", data);
            state.offlineSupportRequests.data = _.uniqBy([...state.offlineSupportRequests.data, ...data], (x) => x._id);
            state.offlineSupportRequests.total = state.offlineSupportRequests.data.length;
        },
        SEND_RESPONSE_OSR: (state, payload) => {
            log.debug("OSR SEND_RESPONSE_OSR", payload);
            let item = state.offlineSupportRequests.data.find((p) => p._id === payload._id);
            item = _.merge(item, payload);
        },
        DELETE_OFFLINE_SUPPORT_REQUEST: (state, id) => {
            log.debug("OSR DELETE_OFFLINE_SUPPORT_REQUEST", id);
            state.offlineSupportRequests.data = state.offlineSupportRequests.data.filter((r) => r._id !== id);
            state.offlineSupportRequests.total--;
            const maybeWaiting = state.waitings.data.find((p) => p._id === id);
            if (maybeWaiting) {
                state.waitings.data = state.waitings.data.filter((r) => r._id !== id);
                state.waitings.total--;
            }
        },
    },
    actions: {
        getOfflineSupportRequests({ commit }, payload) {
            log.debug("getOfflineSupportRequests called", payload);
            return getOfflineSupportRequests(payload).then((response) => {
                if (payload.page === 1) {
                    commit("SET_OFFLINE_SUPPORT_REQUEST", response.data);
                    log.debug("getOfflineSupportRequests2 called", response.data);
                } else if (response.data.data.length > 0) {
                    commit("ADD_OFFLINE_SUPPORT_REQUESTS", response.data.data);
                }
            });
        },
        fetchWaitingOfflineSupportRequests({ commit }, payload) {
            log.debug("getOfflineSupportRequests called", payload);
            return getWaitingOfflineSupportRequests(payload).then((response) => {
                commit("SET_WAITING_OFFLINE_SUPPORT_REQUESTS", response.data);
            });
        },
        newOfflineSupport({ commit }, messagePayload) {
            commit("ADD_OFFLINE_SUPPORT_REQUEST", messagePayload);
        },
        getOfflineSupportRequest({ state }, id) {
            return state.offlineSupportRequests.data.find((p) => p._id === id);
        },
        sendResponse({ commit }, payload) {
            return sendResponse(payload.offlineSupportRequestId, {
                response: payload.response,
                userId: payload.userId,
                offlineSupportRequestId: payload.offlineSupportRequestId,
            }).then((response) => {
                const data = response.data;
                commit("SEND_RESPONSE_OSR", data);
                return Promise.resolve(data);
            });
        },
        deleteOfflineSupportRequest({ commit }, id) {
            return deleteOfflineSupportRequest(id).then((response) => {
                commit("DELETE_OFFLINE_SUPPORT_REQUEST", id);
                return Promise.resolve(response);
            });
        },
    },
};

export default offlineSupportRequest;
